import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-online-evaluation-terms",
  templateUrl: "./online-evaluation-terms.component.html",
  styleUrls: ["./online-evaluation-terms.component.scss"],
})
export class OnlineEvaluationTermsComponent implements OnInit {
  currentYear: number;

  constructor(private dialogRef: MatDialogRef<OnlineEvaluationTermsComponent>) { }

  ngOnInit() {
    this.dialogRef.disableClose = false;
    this.currentYear = new Date().getFullYear();
  }

  close(): void {
    this.dialogRef.close();
  }

}
